import React from 'react';
import * as S from './Styles';
import SVG from '../SVG';
import DualListBoxControl from './DualListBoxControl';

export type DualListBoxItem<T = any> = T & {
  id: number;
  promotionalProductId?: number | null;
  name?: string;
  type: string;
  identifier: number;
};

interface DualListBoxProps {
  selectedItems: DualListBoxItem[];
  availableItems: DualListBoxItem[];
  onSelectItems: (item: DualListBoxItem[]) => void;
  onRemoveItems: (item?: DualListBoxItem[]) => void;
  currentPage: number;
  itemsPerPage: number;
  totalOfItems: number;
  setPage: (number: number) => void;
  setItemsPerPage: (number: number) => void;
  AvailableItemMask?: (props: any) => any;
  SelectedItemMask?: (props: any) => any;
}
const DualListBox = ({
  selectedItems,
  availableItems,
  onSelectItems,
  onRemoveItems,
  currentPage,
  itemsPerPage,
  totalOfItems,
  setPage,
  setItemsPerPage,
  AvailableItemMask = ({ children }) => children,
  SelectedItemMask = ({ children }) => children,
}: DualListBoxProps) => {
  const [markedAvailableItems, setMarkedAvailableItems] = React.useState<
    DualListBoxItem[]
  >([]);
  const [markedSelectedItems, setMarkedSelectedItems] = React.useState<
    DualListBoxItem[]
  >([]);

  const [hoverItemIndex, setHoverItemIndex] = React.useState(-1);

  const markAvailableItem = (item: DualListBoxItem) => {
    const existentMarkedItem = markedAvailableItems.find(
      ({ identifier }) => identifier === item.identifier,
    );
    if (existentMarkedItem) {
      setMarkedAvailableItems(
        markedAvailableItems.filter(
          ({ identifier }) => !(identifier === item.identifier),
        ),
      );
    } else {
      setMarkedAvailableItems([item, ...markedAvailableItems]);
    }
  };

  const markSelectedItem = (item: DualListBoxItem) => {
    const existentMarkedItem = markedSelectedItems.find(
      ({ identifier }) => identifier === item.identifier,
    );
    if (existentMarkedItem) {
      setMarkedSelectedItems(
        markedSelectedItems.filter(
          ({ identifier }) => !(identifier === item.identifier),
        ),
      );
    } else {
      setMarkedSelectedItems([item, ...markedSelectedItems]);
    }
  };

  React.useEffect(() => {
    setMarkedAvailableItems([]);
  }, [availableItems]);

  return (
    <S.Container>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
        }}
      >
        <S.ListBoxContainer>
          <S.ListBox>
            {availableItems.map((item, index) => {
              return (
                <S.Item
                  key={index}
                  onClick={() => {
                    markAvailableItem(item);
                  }}
                  isSelected={
                    !!markedAvailableItems.find(
                      ({ identifier }) => identifier === item.identifier,
                    )
                  }
                >
                  <AvailableItemMask
                    availableItems={availableItems}
                    markedAvailableItems={markedAvailableItems}
                    {...item}
                  />
                </S.Item>
              );
            })}
          </S.ListBox>
        </S.ListBoxContainer>
        <S.ControlsContainer>
          <S.Control
            disabled={!(markedAvailableItems.length > 0)}
            active={markedAvailableItems.length > 0}
            onClick={() => {
              if (markedAvailableItems.length > 0) {
                onSelectItems(markedAvailableItems);
                setMarkedAvailableItems([]);
              }
            }}
          >
            <SVG.Icon.SVGIconReturnRightSet
              color={markedAvailableItems.length > 0 ? '#11465D' : '#a7a7a7'}
              width={20}
              height={20}
            />
          </S.Control>
          <S.Control
            disabled={!(availableItems.length > 0)}
            active={availableItems.length > 0}
            onClick={() => {
              onRemoveItems(markedSelectedItems);
              onSelectItems(availableItems);
            }}
          >
            <SVG.Icon.SVGIconArrowRightDuplo
              color={availableItems.length > 0 ? '#11465D' : '#a7a7a7'}
              width={20}
              height={20}
            />
          </S.Control>

          <S.Control
            disabled={!(markedSelectedItems.length > 0)}
            active={markedSelectedItems.length > 0}
            onClick={() => {
              if (markedSelectedItems.length > 0) {
                onRemoveItems(markedSelectedItems);
                setMarkedSelectedItems([]);
              }
            }}
          >
            <SVG.Icon.SVGIconBackSet
              color={markedSelectedItems.length > 0 ? '#11465D' : '#a7a7a7'}
              width={20}
              height={20}
            />
          </S.Control>
          <S.Control
            disabled={!(selectedItems.length > 0)}
            active={selectedItems.length > 0}
            onClick={() => {
              onRemoveItems();
              setMarkedSelectedItems([]);
            }}
          >
            <SVG.Icon.SVGIconArrowDuplo
              color={selectedItems.length > 0 ? '#11465D' : '#a7a7a7'}
              width={20}
              height={20}
            />
          </S.Control>
        </S.ControlsContainer>
        <S.ListBoxContainer>
          <S.ListBox>
            {selectedItems.map((item, index) => (
              <S.Item
                key={index}
                onClick={() => {
                  markSelectedItem(item);
                }}
                isSelected={
                  !!markedSelectedItems.find(
                    ({ identifier }) => identifier === item.identifier,
                  )
                }
                onMouseEnter={() => {
                  setHoverItemIndex(index);
                }}
                onMouseLeave={() => {
                  setHoverItemIndex(-1);
                }}
              >
                <SelectedItemMask
                  hover={hoverItemIndex === index}
                  selectedItems={selectedItems}
                  markedSelectedItems={markedSelectedItems}
                  {...item}
                />
              </S.Item>
            ))}
          </S.ListBox>
        </S.ListBoxContainer>
        <S.BottomControlsContainer>
          {/* <DualListBoxControl
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalOfItems={totalOfItems}
            setPage={setPage}
            setItemsPerPage={setItemsPerPage}
          ></DualListBoxControl> */}
        </S.BottomControlsContainer>
        <div />
      </div>
    </S.Container>
  );
};

export default DualListBox;
